var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "account__data",
      class: { active: _vm.dropZoneActive, complete: _vm.dropzoneShow }
    },
    [
      _c("h3", { staticClass: "stepper__title gray" }, [
        _vm._v("Requisitos de afiliación")
      ]),
      !_vm.dropZoneActive
        ? _c("div", { staticClass: "account__data_details" }, [
            _c("p", { staticClass: "account__subtitle" }, [
              _vm._v("Documentos que debes subir")
            ]),
            _vm._m(0)
          ])
        : _vm._e(),
      _c(
        "no-ssr",
        [
          _c("dropzone", {
            ref: "dropzone",
            staticClass: "dropzone-label",
            attrs: {
              id: "dropzone",
              options: _vm.dropzoneOptions,
              awss3: _vm.awss3
            },
            on: {
              "vdropzone-sending": _vm.sending,
              "vdropzone-removed-file": _vm.removedFile,
              "vdropzone-success": _vm.success,
              "vdropzone-file-added": _vm.fileAdded,
              "vdropzone-s3-upload-error": _vm.s3UploadError,
              "vdropzone-s3-upload-success": _vm.s3UploadSuccess,
              "vdropzone-renameFile": _vm.renameFile,
              "vdropzone-error": _vm.uploadError,
              "vdropzone-s3-upload-unauthorized": _vm.unauthorizedError
            },
            model: {
              value: _vm.dropZone,
              callback: function($$v) {
                _vm.dropZone = $$v
              },
              expression: "dropZone"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c(
            "v-btn",
            {
              staticClass: "primary-button afilliation__btn",
              class: { active: _vm.canContinue },
              attrs: { disabled: _vm.loading || !_vm.canContinue },
              on: { click: _vm.submit }
            },
            [_vm._v("Continuar")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "primary-button text black capitalize",
              attrs: { small: "" },
              on: {
                click: function($event) {
                  _vm.changeStep(false)
                }
              }
            },
            [_vm._v("Atrás")]
          ),
          _c("loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "loaderModal",
            attrs: { text: "Subiendo Archivos" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "account_list" }, [
      _c("li", [
        _vm._v(
          "- Por cuenta bancaria debes subir una imagen donde se vea la cuenta bancaria y la razón social"
        )
      ]),
      _c("li", [
        _vm._v(
          "- También debes subir una imagen que identifique al comercio (foto del local, boleta de venta)."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49914989", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49914989","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/membership-requirements.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-49914989","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/membership-requirements.vue
// module chunks = 0 1 2 3